import isEmpty from 'lodash-es/isEmpty';

import { IMAGE_STATUS } from '@ecp/common/src/const/imageFile';

export const formValidators = {
  mobileImageFileList: [
    {
      when: ['always'],
      message: '이미지를 모두 등록해주세요.',
      validator: ({ mobileImageFileList, mobileLogoBasicUseYn }) =>
        !(
          mobileLogoBasicUseYn === 'N' &&
          mobileImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length < 2
        ),
    },
  ],
  loginImageFileList: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ loginImageFileList, mobileLoginBasicUseYn }) =>
        !(
          mobileLoginBasicUseYn === 'N' &&
          loginImageFileList.filter(({ status }) => status !== IMAGE_STATUS.NEED_TO_DEL).length <= 0
        ),
    },
  ],
  loginPhrase01: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ loginPhrase01 }) => !isEmpty(loginPhrase01),
    },
  ],
  loginPhrase02: [
    {
      when: ['always'],
      message: '이미지와 문구를 모두 등록해주세요.',
      validator: ({ loginPhrase02 }) => !isEmpty(loginPhrase02),
    },
  ],
};

export const typeOptions = [
  { value: 'Y', label: '기본형' },
  { value: 'N', label: '직접입력' },
];

export const mobileImageItemList = (basic = 'N') => [
  { desc: basic === 'Y' ? 'GNB' : 'GNB\n(44*36)', key: 'mobileGnbImgFileId', width: 400, height: 400 },
  {
    desc: basic === 'Y' ? 'Footer' : 'Footer\n(100*15)',
    key: 'mobileFooterImgFileId',
    width: 400,
    height: 400,
  },
];

export const loginLogoImageItemList = (basic = 'N') => [
  {
    desc: basic === 'Y' ? 'LOGO' : 'LOGO\n(232*48)',
    key: 'mobileLoginImgFileId',
    width: 400,
    height: 400,
  },
];

export const initialForm = {
  mobileLogoBasicUseYn: 'Y',
  mobileImageFileList: [],
  mobileLoginBasicUseYn: 'Y',
  loginImageFileList: [],
  loginPhrase01: '',
  loginPhrase02: '',
};

export const initialError = {
  mobileImageFileList: '',
  loginImageFileList: '',
  loginPhrase01: '',
  loginPhrase02: '',
};
